document.addEventListener('DOMContentLoaded', function() {
  const faqItems = document.querySelectorAll('[data-faq-pdp-item]');

  faqItems.forEach(item => {
    const question = item.querySelector('[data-faq-pdp-question]');
    const answer = item.querySelector('[data-faq-pdp-answer]');

    question.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      if (isOpen) {
        // Close
        answer.style.maxHeight = '0';
        item.classList.remove('is-open');
      } else {
        // Open
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
});